import {Component, OnInit} from '@angular/core';
import {ContactMethodResponse} from "../../models/Common/contactMethodResponse";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {NgxSpinnerService} from "ngx-spinner";
import {OrganizationService} from "../../services/organization.service";
import {CommonService} from "../../services/common.service";
import {ActivatedRoute, Router} from "@angular/router";
import swal from "sweetalert2";

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit{

  contactMethods: ContactMethodResponse[] = [];

  contactForm: FormGroup = new FormGroup({
    organizationId: new FormControl('', Validators.required),
    contactInfo: new FormGroup({
      firstName: new FormControl('',[Validators.required,Validators.maxLength(50)]),
      lastName: new FormControl('',[Validators.required,Validators.maxLength(50)]),
      position: new FormControl('',[Validators.required,Validators.maxLength(100)]),
      email: new FormControl('',[Validators.required,Validators.maxLength(100)]),
      phone: new FormControl('',[Validators.required,Validators.maxLength(50)]),
      contactMethodId: new FormControl('', Validators.required),
    })
  });

  constructor(private spinner: NgxSpinnerService,
              private organizationService:OrganizationService,
              private commonService:CommonService,
              private route: ActivatedRoute,
              private router: Router) {
    this.route.queryParams.subscribe((params) => {
      const name = params['organizationId'];
      if (name) {
        this.contactForm.get('organizationId')?.setValue(name);
      }
    });
  }

  ngOnInit() {
    this.spinner.show();
    Promise.all([
      this.loadContactMethods(),
    ]).finally(() => this.spinner.hide());
  }

  loadContactMethods() {

    return new Promise<void>((resolve, reject) => {
      this.commonService.getContactMethod().subscribe({
        next: (response) => {
          this.contactMethods = response.item || [];
          resolve();
        },
        error: (error) => {
          console.error("Error loading contact methods", error);
          reject(error);
        }
      })
    });
  }


  async onSubmit() {
    if (this.contactForm.invalid) {


      if (this.contactForm.invalid) {
        Object.keys(this.contactForm.controls).forEach(key => {
          const control = this.contactForm.get(key);
          if (control instanceof FormGroup) {
            Object.keys(control.controls).forEach(innerKey => {
              control.get(innerKey)?.markAsTouched();
            });
          } else {
            control?.markAsTouched();
          }
        });
      }

      await swal.fire({
        title: 'Form Invalid',
        html: `Please correct the invalid field.`,
        icon: 'warning',
        confirmButtonText: 'OK',
      });


    } else {
      const formData = this.contactForm.value;
      await this.spinner.show();

      this.organizationService.addContact(formData).subscribe({
        next: async (response) => {
         await this.spinner.hide();
          if (response.result) {

            await swal.fire({
              title: 'The contact  has been submitted successfully.',
              icon: 'success',
              confirmButtonText: 'OK',
            }).then(() => {
              this.router.navigate(['/organization']);
            });
          } else {
           await swal.fire({
              title: response.messages?.join(','),
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }
        },
        error: (error) => {
          this.spinner.hide();
          console.error("Error occurred while creating organization", error);
        }
      });
    }
  }

  getInvalidFields(form: FormGroup): string[] {
    const invalidFields: string[] = [];
    Object.keys(form.controls).forEach(key => {
      const control = form.get(key);
      if (control instanceof FormGroup) {
        invalidFields.push(...this.getInvalidFields(control));
      } else if (control && control.invalid) {
        invalidFields.push(key);
      }
    });
    return invalidFields;
  }


}
